module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-6-69f8038c9aaf11a060d19ae9710c37a38be085e982e088a3b7c12002f64001af.svg";